import {HoneypotFieldParams} from "./honeypot-field-params";

export interface VerificationCreateParams {
  siteKey: string;
  widget: VerificationWidgetParams;
  metadata: VerificationMetadataParams;
  browserInformation: { [key: string]: any };
  fingerprints: VerificationFingerprintsParams;
  honeypotFields: HoneypotFieldParams[];
  userEvents: any[];
  integrityHash: string;
}

export interface VerificationWidgetParams {
  boxCreationTimestamp: Date;
  startSolvingTimestamp: Date;
  timezone: string;
  minimalDataMode: boolean;
  bypassToken: string | null;
  settings: { [key: string]: any };
}

export interface VerificationMetadataParams {
  framework: string | null;
  libraryVersion: string;
}

export interface VerificationFingerprintsParams {
  audio: string;
  canvas: string;
  webgl: string;
  fonts: string;
  navigator: string;
  screen: string;
}
